import { ListItemButton, ListItemText } from "@mui/material";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";

export default function LoadMoreButton({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <ListItemButton onClick={onClick} sx={{ justifyContent: "center" }}>
      <ListItemText
        primary={label}
        primaryTypographyProps={{
          fontSize: "12px",
          fontWeight: 600,
          textAlign: "center",
          color: draftColors.blue,
        }}
      />
    </ListItemButton>
  );
}
